import React, { FC } from 'react';

import MediaContentItem from './MediaContentItem';
import { MediaContentProps } from './types';

const MediaContent: FC<MediaContentProps> = ({
  handleImageDelete,
  selectedImageUrl,
  onSelectImage,
  searchQuery,
  images = [],
  onDoubleClick,
  setIsCopying
}) => {
  const filteredImages = images.filter(({ name }) =>
    name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="h-[440px] overflow-y-scroll">
      <div className="grid grid-cols-4 gap-2 my-4">
        {[...filteredImages]
          .reverse()
          .map(({ name, url, type, mediaId, mimeType }, i) => (
            <MediaContentItem
              handleImageDelete={handleImageDelete}
              name={name}
              url={url}
              type={type}
              mediaId={mediaId}
              mimeType={mimeType}
              key={i}
              isSelected={selectedImageUrl === url}
              onSelect={() => onSelectImage(url)}
              onDoubleClick={onDoubleClick}
              setIsCopying={setIsCopying}
            />
          ))}
      </div>
    </div>
  );
};

export default MediaContent;
